module.exports = __webpack_public_path__ + "components/layout/images/back.png?4206599f";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/back.png
// module id = 233
// module chunks = 0